module.exports = __webpack_public_path__ + "static/img/eyebrows_07.02024be.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyebrows/thumbnail/eyebrows_07.png
// module id = 9ylp
// module chunks = 0